/* unplugin-vue-components disabled */import { render } from "./edit-company.vue?vue&type=template&id=c004202a&scoped=true"
import script from "./edit-company.vue?vue&type=script&lang=js"
export * from "./edit-company.vue?vue&type=script&lang=js"

import "./edit-company.vue?vue&type=style&index=0&id=c004202a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c004202a"],['__file',"src/pages/pulse/tracker/edit-company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c004202a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c004202a', __exports__)) {
    api.reload('c004202a', __exports__)
  }
  
  module.hot.accept("./edit-company.vue?vue&type=template&id=c004202a&scoped=true", () => {
    api.rerender('c004202a', render)
  })

}


export default __exports__